import { render, staticRenderFns } from "./DetailListCdps.vue?vue&type=template&id=1a0fba63&"
import script from "./DetailListCdps.vue?vue&type=script&lang=ts&"
export * from "./DetailListCdps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports